import { render } from "./USRComponent.vue?vue&type=template&id=71edfb6e"
import script from "./USRComponent.vue?vue&type=script&lang=ts"
export * from "./USRComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script